import { render, staticRenderFns } from "./BtnVoltar.vue?vue&type=template&id=4a2e73d8"
import script from "./BtnVoltar.vue?vue&type=script&lang=js"
export * from "./BtnVoltar.vue?vue&type=script&lang=js"
import style0 from "./BtnVoltar.vue?vue&type=style&index=0&id=4a2e73d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
